import React from 'react';

const DeviceAuthorized: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full mx-auto flex items-center justify-center mb-6">
          <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">Device Authorized!</h1>
        <p className="text-gray-600 mb-6">
          You can now close this window and return to your device.
        </p>

        <div className="p-4 bg-blue-50 rounded-lg">
          <p className="text-sm text-gray-600">
            Your device is now connected to your account and ready to use.
          </p>
        </div>

        <button
          onClick={() => window.close()}
          className="mt-6 text-blue-600 hover:underline text-sm"
        >
          Close this window
        </button>
      </div>
    </div>
  );
};

export default DeviceAuthorized;
